;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type { CountryVatFormat } from '../types/country';

export const DEFAULT_VAT_FORMAT: CountryVatFormat = {
  format: '4–20 letters or numbers (max 20 characters)',
  example: 'ABCD1234',
  regex: '^[A-Z0-9]{4,20}$',
};

const VAT_SEPARATOR_PATTERN = /[\s.\-/]/g;

export function normalizeVatNumber(value: string): string {
  return value.toUpperCase().replace(VAT_SEPARATOR_PATTERN, '');
}

export function getCountryVatFormat(vatFormat?: CountryVatFormat): CountryVatFormat {
  if (!vatFormat?.regex || !vatFormat.example) return DEFAULT_VAT_FORMAT;

  return vatFormat;
}

function matchesVatRegex(normalizedValue: string, regex: string): boolean {
  try {
    return new RegExp(regex).test(normalizedValue);
  } catch {
    return new RegExp(DEFAULT_VAT_FORMAT.regex).test(normalizedValue);
  }
}

export function isValidEmployerVatNumber(value: string, vatFormat?: CountryVatFormat): boolean {
  const normalizedValue = normalizeVatNumber(value);
  if (!normalizedValue) return value.trim() === '';

  const format = getCountryVatFormat(vatFormat);
  return matchesVatRegex(normalizedValue, format.regex);
}

export function isValidAdminVatNumber(value: string): boolean {
  const normalizedValue = normalizeVatNumber(value);
  if (!normalizedValue) return value.trim() === '';

  return matchesVatRegex(normalizedValue, DEFAULT_VAT_FORMAT.regex);
}

export function getVatNumberErrorMessage(example: string): string {
  return `Invalid VAT number format. Example: ${example}`;
}

export function getVatNumberTooltip(
  countryName: string,
  vatFormat?: CountryVatFormat
): string | undefined {
  if (!countryName || !vatFormat?.label) return undefined;

  return `In ${countryName} this is your ${vatFormat.label}, e.g. ${vatFormat.example}`;
}

export function getVatNumberPlaceholder(vatFormat?: CountryVatFormat, hasCountry = false): string {
  if (!hasCountry) return 'Type here';

  return `e.g. ${getCountryVatFormat(vatFormat).example}`;
}
